const SettingKeys = {
  ///// Estimation Module Setting Keys ///////
  MIN_MARKER_PERCENT: "min_marker_percent",
  REGROUPING_WIDTH_TOLERANCE: "regrouping_width_tolerance",
  REGROUPING_WARP_TOLERANCE: "regrouping_warp_tolerance",
  REGROUPING_WEFT_TOLERANCE: "regrouping_weft_tolerance",
  APPLY_WEIGHTED_MEAN_FOR_SHRINKAGE: "apply_weighted_mean_for_shrinkage",
  WIDTH_UPGRADE_TOLERANCE: "width_upgrade_tolerance", //Maximum width above which upgrade should not be performed
  WIDTH_UPGRADE_SIZE_TOLERANCE_TYPE: "width_upgrade_size_tolerance_type", //Abosulte|Relative
  WIDTH_UPGRADE_SIZE_TOLERANCE_VALUE: "width_upgrade_size_tolerance_value",
  SIGNIFICANT_SHADE_CUT_OFF_PERCENT: "significant_shade_cut_off_percent", // If any shade contribution is less than this value, it is combined in Other Shade category.
  COSTING_REASONS: "costing_reasons",
  ESTIMATION_REASONS: "estimation_reasons",

  //// Warehouse Setting ////
  FABRIC_RELEASE_CONFIRMATION: "fabric_release_confirmation",
  FABRIC_GROUPING_FROM_FPO_WAREHOUSE: "fabric_grouping_from_fpo_warehouse",

  //// Grouping Setting Keys ////
  ENABLE_PATTERN_NUMBER_OVERRIDE: "enable_pattern_number_override",
  FABRIC_ALLOCATION_POSITIVE_TOLERANCE: "fabric_allocation_positive_tolerance", // Positive tolerance while allocating fabric (Grouping)
  FABRIC_ALLOCATION_NEGATIVE_TOLERANCE: "fabric_allocation_negative_tolerance", // Negative tolerance while allocating fabric (Grouping)
  PREFILL_ASSOCIATION_QTY: "prefill_association_qty",

  ///// Cut Plan Setting Keys ///////
  RCU_SIZE_JUMP_CONSTANT: "rcu_size_jump_constant",
  RCU_WAY_CONSTANT: "rcu_way_constant",
  MARKER_ENDLOSS: "marker_endloss",
  ENDLOSS_INCLUDED_IN_MARKER: "endloss_included_in_marker",
  ENABLE_MARKER_PERIMETER_UPDATE: "enable_marker_perimeter_update",
  MARKER_WAYS_DISCARDED: "discarded_ways",
  ENFORCE_CUTPLAN_APPROVAL: "enforce_cutplan_approval",
  ENFORCE_CUTPLAN_VARIANCE_ANALYSIS: "enforce_cutplan_variance_analysis",
  MAIN_WIDTH_REGROUPING_TOLERANCE: "main_width_re_grouping_tolerance",
  REMNANT_WIDTH_REGROUPING_TOLERANCE: "remnant_width_re_grouping_tolerance",
  EXTRA_FABRIC_POSITIVE_TOLERANCE: "extra_fabric_positive_tolerance", // Positive tolerance while selecting rolls for returning extra fabric
  EXTRA_FABRIC_NEGATIVE_TOLERANCE: "extra_fabric_negative_tolerance", // Negative tolerance while selecting rolls for returning extra fabric
  DEFAULT_VALUE_AVG_END_BIT_PER_ROLL: "default_value_avg_end_bit_per_roll", // Default value for Average end bit per roll. While generating Cut Plan, this value is used to calculate end bit fabric.
  MIN_ROLL_SPLIT_LENGTH: "min_roll_split_length",
  EXHAUSTED_ROLL_FRACTION: "exhausted_roll_fraction", // A roll is said to be exhausted if its length is less than fraction * cu. While running remnant roll plan, Exhausted rolls are not sent to Planner.
  AVG_REMNANT_ROLL_LENGTH: "avg_remnant_roll_length", // Average length of remnant rolls. While calculating end bits, rolls equivalent to reservedFabric/avgRemnantLength are excluded.
  END_BIT_CSV_MULTIPLIER: "end_bit_csv_multiplier", // Csv multiplier for calculating end bits of CSV order
  ROLL_PLAN_RESERVE_FABRIC_MARKER_LENGTH_FRACTION: "roll_plan_reserve_fabric_marker_length_fraction", // Reserve fabric while running main roll plan corresponding to remnants. reservedFabric : fraction * largestML * rollCount
  MULTI_PART_BUNDLING: "multi_part_bundling", // Bundling Logic in case of multiple part
  SHOW_STD_CU: "show_std_cu",
  PRODUCTION_TYPES: "production_types",
  WASTAGE_PERCENT: "wastage_percent",
  ALLOWED_CSV_VALUES: "allowed_csv_values",

  ///// Feedback Setting Keys ///////
  MIN_ROLL_RETURN_LENGTH: "min_roll_return_length",
  TICKET_PAGE_FORMAT: "ticket_page_format",
  LAYSLIP_DEVIATION_CAUSES: "layslip_deviation_causes",
  DEFECT_TYPES: "defect_types",
  CAPTURE_RE_CUT_END_BITS_ROLL_WISE: "capture_re_cut_end_bits_roll_wise",
  PANEL_REPLACEMENT_TRACEABLE: "panel_replacement_traceable",
  BUNDLE_EXPORT_FIELDS: "bundle_export_fields",
  BUNDLE_TAG_SETTING: "bundle_tag_setting",
  ENABLE_BUNDLE_PIECE_TAG: "enable_bundle_piece_tag",
  PIECE_TAG_SETTING: "piece_tag_setting",
  NUMBERING_SERIAL_RESET_DIGITS: "numbering_serial_reset_digits",
  CUT_QTY_SYNC_EVENT: "cut_qty_sync_event",
  PRE_CUTTING_DEPARTMENT_NAME: "pre_cutting_department_name",

  REASON_FOR_FABRIC_LEFTOVER_FACTORY:"reason_for_fabric_leftover_factory",
  REASON_FOR_HIGHER_RE_CUT:"reason_for_higher_re_cut",
  REASON_FOR_HIGHER_END_BITS_LEFTOVER:"reason_for_higher_end_bits_leftover",
  RECUTTING_THRESHOLD_PERCENT: "recutting_threshold_percent",
  HIGHER_END_BITS_THRESHOLD_PERCENT: "higher_end_bits_threshold_percent",

  ///// Alert Setting Keys ///////
  CONSUMPTION_INCREASE: "consumption_increase",
  CONSUMPTION_DECREASE: "consumption_decrease",
  HIGH_SPLITTING: "high_splitting",
  LESS_ACTUAL_WIDTH: "less_actual_width",
  LOW_MARKER_EFFICIENCY: "low_marker_efficiency",

  ///// Other Setting Keys ///////
  LINES: "lines",
  IS_LINE_REQUIRED: "is_line_required",
  GARMENT_PARTS: "garment_parts",
  TASK_EXPIRY: "task_expiry",
  SUIT_GARMENTS: "suit_garments",
  PRODUCT_PARTS: "product_parts",
  ROLL_SPLIT_CHARACTER: "roll_split_character",
  DISABLE_ENTITIES_DELETE: "disable_entities_delete",
  DISABLE_ENTITIES_EDIT: "disable_entities_edit",
  DISABLE_ENTITIES_CREATE: "disable_entities_create",
  UOM_CONVERSION_FACTOR: "uom_conversion_factor",
  ALLOW_MULTI_INVOICE_AUTO_ALLOCATION: "allow_multi_invoice_auto_allocation",
  ENABLE_EXTERNAL_FPO_MERGE: "enable_external_fpo_merge",
  ALLOW_FPO_WITH_EXTRA: "allow_fpo_with_extra_shipment",
  WFX_WMS_INTEGRATION_ENABLED: "wfx_wms_integration_enabled",
  FINANCIAL_YEAR_START_MONTH: "financial_year_start_month",
  WEEK_START_DAY: "week_start_day",
  DISABLED_EMAIL_EVENTS: "disabled_email_events",

  ENTITY_FIELDS: "entity_fields",
  ENTITY_FIELD_VALIDATION: "entity_field_validation",

  MARKER_PLY_LIMIT: "marker_ply_limit",
  MARKER_END_LOSS: "marker_endloss"
};

export default SettingKeys;
